import { render, staticRenderFns } from "./changePassDialog.vue?vue&type=template&id=9ef9bba4"
import script from "./changePassDialog.vue?vue&type=script&lang=js"
export * from "./changePassDialog.vue?vue&type=script&lang=js"
import style0 from "./changePassDialog.vue?vue&type=style&index=0&id=9ef9bba4&prod&lang=scss&rel=stylesheet%2Fscss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports